import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class ValidaRecuperarPassValidaSmsService implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (sessionStorage.getItem('recuperarPassClaveV') != null) {
      return true;
    } else {
      /* // Si no esta activa la sesion, redirecciona al login
      console.log("Security");*/
      this.router.navigate(['inicio']);
      return false;
    }

  }

}